module.exports = __webpack_public_path__ + "static/img/wangping.cd644b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/wangping.png
// module id = dSI4
// module chunks = 0